import React from 'react';
import PropTypes from 'prop-types';

import { getClass } from '../../../utils/component-helpers';

import { ReactComponent as CaretDown } from '../../../images/icons/caret-down.svg';
import { ReactComponent as CaretUp } from '../../../images/icons/caret-up.svg';
import { ReactComponent as GraphIcon } from '../../../images/icons/graph-v2.svg';
import { ReactComponent as CircleXIcon } from '../../../images/icons/circle-x.svg';
import { ReactComponent as MoreIcon } from '../../../images/icons/more.svg';
import { ReactComponent as PlusIcon } from '../../../images/icons/plus-v2.svg';
import { ReactComponent as LinkInIcon } from '../../../images/icons/link-in.svg';
import { ReactComponent as ArrowUpIcon } from '../../../images/icons/arrow-up.svg';
import { ReactComponent as ArrowDownIcon } from '../../../images/icons/arrow-down.svg';
import { ReactComponent as DotIcon } from '../../../images/icons/dot-v2.svg';
import { ReactComponent as LiveIcon } from '../../../images/icons/live-v2.svg';
import { ReactComponent as FileIcon } from '../../../images/icons/filecsv-v2.svg';
import { ReactComponent as SearchIcon } from '../../../images/icons/search.svg';
import { ReactComponent as XIcon } from '../../../images/icons/x.svg';
import { ReactComponent as GearIcon } from '../../../images/icons/icon-gear.svg';
import { ReactComponent as CreditCardIcon } from '../../../images/icons/icon-credit-card.svg';
import { ReactComponent as WrenchIcon } from '../../../images/icons/icon-wrench.svg';
import { ReactComponent as StripeLogoIcon } from '../../../images/icons/icon-logo-stripe.svg';
import { ReactComponent as CheckIcon } from '../../../images/icons/icon-checkmark-v2.svg';
import { ReactComponent as FilledAlertIcon } from '../../../images/icons/icon-alert-filled.svg';
import { ReactComponent as AlertIcon } from '../../../images/icons/icon-alert.svg';
import { ReactComponent as StrategiesIcon } from '../../../images/icons/strategies.svg';
import { ReactComponent as CampaignsIcon } from '../../../images/icons/campaigns.svg';
import { ReactComponent as ChevronRightIcon } from '../../../images/icons/chevron-right.svg';
import { ReactComponent as ChevronUpIcon } from '../../../images/icons/chevron-up.svg';
import { ReactComponent as ChevronDownIcon } from '../../../images/icons/chevron-down.svg';
import { ReactComponent as BookmarkIcon } from '../../../images/icons/bookmark.svg';
import { ReactComponent as BookmarkFilledIcon } from '../../../images/icons/bookmark-filled.svg';
import { ReactComponent as YoutubeLogoIcon } from '../../../images/icons/icon-logo-youtube.svg';
import { ReactComponent as HomeIcon } from '../../../images/icons/home.svg';
import { ReactComponent as DocumentIcon } from '../../../images/icons/document.svg';
import { ReactComponent as BarGraphIcon } from '../../../images/icons/bar-graph.svg';
import { ReactComponent as LightningBoltIcon } from '../../../images/icons/lightning-bolt.svg';
import { ReactComponent as ShoppingBagIcon } from '../../../images/icons/shopping-bag.svg';
import { ReactComponent as InstagramLogoIcon } from '../../../images/icons/icon-logo-instagram.svg';
import { ReactComponent as CopyIcon } from '../../../images/icons/icon-copy.svg';
import { ReactComponent as ArrowRightIcon } from '../../../images/icons/arrow-right.svg';
import { ReactComponent as ColumnsIcon } from '../../../images/icons/columns.svg';
import { ReactComponent as KebabIcon } from '../../../images/icons/icon-kebab.svg';
import { ReactComponent as LinkOutIcon } from '../../../images/icons/linkout.svg';
import { ReactComponent as PurseIcon } from '../../../images/icons/icon-purse.svg';
import { ReactComponent as PencilIcon } from '../../../images/icons/icon-pencil.svg';
import { ReactComponent as DocumentsIcon } from '../../../images/icons/docs.svg';
import { ReactComponent as KeywordsIcon } from '../../../images/icons/keywords.svg';
import { ReactComponent as CollectionsIcon } from '../../../images/icons/collections.svg';
import { ReactComponent as NewProductsIcon } from '../../../images/icons/new-product.svg';
import { ReactComponent as SalesTagIcon } from '../../../images/icons/sale-tag.svg';
import { ReactComponent as HeroProductsIcon } from '../../../images/icons/hero-products.svg';
import { ReactComponent as CircleCheckIcon } from '../../../images/icons/circle-check.svg';
import { ReactComponent as EyeIcon } from '../../../images/icons/public-eye.svg';

import './icon.scss';

export const icons = {
  dot: DotIcon,
  live: LiveIcon,
  file: FileIcon,
  search: SearchIcon,
  x: XIcon,
  gear: GearIcon,
  creditCard: CreditCardIcon,
  wrench: WrenchIcon,
  stripeLogo: StripeLogoIcon,
  check: CheckIcon,
  filledAlert: FilledAlertIcon,
  alert: AlertIcon,
  strategies: StrategiesIcon,
  campaigns: CampaignsIcon,
  chevronRight: ChevronRightIcon,
  chevronUp: ChevronUpIcon,
  chevronDown: ChevronDownIcon,
  caretUp: CaretUp,
  caretDown: CaretDown,
  graph: GraphIcon,
  circleX: CircleXIcon,
  more: MoreIcon,
  plus: PlusIcon,
  linkIn: LinkInIcon,
  arrowUp: ArrowUpIcon,
  arrowDown: ArrowDownIcon,
  bookmark: BookmarkIcon,
  bookmarkFilled: BookmarkFilledIcon,
  youtubeLogo: YoutubeLogoIcon,
  home: HomeIcon,
  document: DocumentIcon,
  barGraph: BarGraphIcon,
  lightningBolt: LightningBoltIcon,
  shoppingBag: ShoppingBagIcon,
  instagramLogo: InstagramLogoIcon,
  copy: CopyIcon,
  arrowRight: ArrowRightIcon,
  columns: ColumnsIcon,
  kebab: KebabIcon,
  linkOut: LinkOutIcon,
  purse: PurseIcon,
  pencil: PencilIcon,
  docs: DocumentsIcon,
  keywords: KeywordsIcon,
  collections: CollectionsIcon,
  heroProducts: HeroProductsIcon,
  newProducts: NewProductsIcon,
  salesTag: SalesTagIcon,
  circleCheck: CircleCheckIcon,
  eye: EyeIcon,
};

const Icon = props => {
  const { iconName, size, color } = props;

  const IconComponent = icons[iconName];

  if (!IconComponent) {
    return null;
  }

  const iconClasses = getClass('icon-container');

  return (
    <div
      className={iconClasses}
      style={{
        height: `${size}px`,
        width: `${size}px`,
        color: color || 'inherit',
      }}
    >
      <IconComponent />
    </div>
  );
};

Icon.propTypes = {
  color: PropTypes.string,
  iconName: PropTypes.oneOf(Object.keys(icons)).isRequired,
  size: PropTypes.number,
};

Icon.defaultProps = {
  color: null,
  size: 16,
};

export default Icon;
